const USER_ID_KEY = 'grafbase:user:id'

export const setUserIdToLocalStorage = (userId: string) => {
  localStorage?.setItem(USER_ID_KEY, userId)
}

export const removeUserIdFromLocalStorage = () => {
  localStorage?.removeItem(USER_ID_KEY)
}
